<template>
<div class="container-fluid">
	<toolbar>
		<router-link to="/financial/invoices" class="btn btn-link">
			<i class="fa fa-caret-left fa-2x"></i>
			<h2>
				Invoices
			</h2>
		</router-link>
	</toolbar>

	<invoice-ui
		:is-for-single-service="false"
		:invoice-slug="invoiceSlug"
		v-on:invoiceSlugChange="setInvoiceSlug">
	</invoice-ui>
</div>
</template>
<script type="text/javascript">
import Toolbar from "@/layout_fragments/Toolbar"
import InvoiceUi from "./InvoiceUi"

import ServiceMixins from "@/mixins/ServiceMixins.js"

export default {
	name: "GroupInvoice",
	components: {
		Toolbar,
		InvoiceUi
	},
	mixins: [ServiceMixins],
	data() {
		return {
			invoiceSlug: null,
			invoiceId: null
		}
	},
	computed: {
		servicesIds() {
			return this.invoiceServices.map(service => service.id)
		},
		worksheetChanged() {
			let serviceChange = this.moment(this.$store.service.updated_at)
			let invoiceGenerated = this.moment(this.invoiceDetails.created_at)

			if (serviceChange.isAfter(invoiceGenerated))
				return true

			return false
		}
	},
	methods: {
		setInvoiceSlug(slug) {
			this.invoiceSlug = slug

			window.history.replaceState({},"","/invoice/"+slug+"/"+this.$route.params.tab)
		}
	},
	created() {
		this.setInvoiceSlug(this.$route.params.slug)
	}
}
</script>

<style type="text/css" scoped>

	.incomplete-alert, .worksheet-change-alert {
		margin-left: -15px;
		margin-right: -15px;
		margin-top: -10px;
		margin-bottom: 10px;
		border-radius: 0;
	}

	@media (max-width: 1200px) {

		.incomplete-alert, .worksheet-change-alert {
			margin-top: -15px
		}
	}

	@media (max-width: 767px) {
		.incomplete-alert, .worksheet-change-alert {
			margin-top: -34px;
		}
	}
</style>